import React from "react";
import { Button, Card, Row, Col, Upload } from "antd";
import { RcFile } from "antd/es/upload";

interface BackgroundImagesProps {
  backgroundImages: { [key: string]: string };
  handleFileChange: (file: RcFile, cardType: string) => boolean;
}

export const BackgroundImages: React.FC<BackgroundImagesProps> = ({
  backgroundImages,
  handleFileChange,
}) => {
  const cardTypes = [
    { key: "customizeActivity", label: "Customize Activity" },
  ];

  return (
    <Card className="w-full shadow-sm rounded-2xl p-6 mt-4 mx-auto">
      <Row gutter={[16, 16]}>
        {cardTypes.map((cardType) => (
          <Col key={cardType.key} xs={24} sm={12} lg={8}>
            <div className="mb-4">
              <h3 className="text-lg font-semibold mb-2">{cardType.label}</h3>
              <Upload
                beforeUpload={(file: RcFile) =>
                  handleFileChange(file, cardType.key)
                }
                showUploadList={false}
                accept="image/*"
              >
                <Button className="w-full bg-blue-500 text-white hover:bg-blue-600 rounded-xl py-2">
                  อัปโหลดรูปภาพ
                </Button>
              </Upload>
              {backgroundImages[cardType.key] && (
                <div className="mt-2">
                  <img
                    src={backgroundImages[cardType.key]}
                    alt="background"
                    className="w-full h-auto rounded-xl"
                  />
                </div>
              )}
            </div>
          </Col>
        ))}
      </Row>
    </Card>
  );
};
